const getters = {
    currentUser: state => state.user.currentUser,
    projectApprovalId: state => state.project.id,
    projectApprovalStep: state => state.project.step,
    current: state => state.project.current,
    menuIsCollapse: state => state.system.menuIsCollapse,
    projectApprovalMaxStep: state => state.project.maxStep, // 目前最大执行步骤
    projectApprovalSteps: state => state.project.steps, // 定向采购步骤
    // 全局新增编辑loading
    loadingBtn: state => state.loading.status,
    securityPermissions:state=>state.user.currentUser.securityPermissions,
    port:state=>state.port.port
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js